<template>
    <div class="page-content">

        <div id="meditationlist" class="section grow bg-svg-skiingtetons">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Journeys to take your imagination somewhere new</h1>
                        <p class="lead mb-10">Experience a relaxing, visually-descriptive adventure as told by our professional narrators.</p>
                        <div class="col-sm-12 ml-auto mr-auto mb-5">
                            <div class="row">
                                <media-artwork v-for="(item, itemKey, index) in filteredMedia.JOURNEY"
                                    class="mb-3 col-sm-12 col-md-6 col-lg-3"
                                    v-bind:emitName="emit_config.emitter"
                                    v-bind:emitPool="emit_config.pool"
                                    v-bind:item="item"
                                    v-bind:itemKey="itemKey"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:showPremiumBadge="true"
                                    v-bind:showTypeBadge="false"
                                    v-bind:showCastButton="false"
                                    v-bind:showTitle="true"
                                    v-bind:showControls="false"
                                    v-bind:hoverEffect="true"
                                    v-bind:linkToDetail="true"
                                    ref="preview"
                                />
                            </div>
                        </div>

                        <p class="mb-10">
                            <a href="/journeys/print" type="button" class="btn btn-outline-light">Click here for a printer-friendly list</a>
                        </p>

                        <h1 class="title color-white mb-5">Install Sleep Jar today!</h1>

                        <div class="row text-center">
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.quick_launch.alexa" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Android</a>
                            </div>
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>iPhone</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
                            </div>
                        </div>

                        <p class="lead mt-10"><small class="opacity-50">Journeys are not yet available on Fire TV.</small></p>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
    data () {
        return {
            "media": require('../assets/media.js'),
            "emit_config": {
                "pool": "journeys",
                "emitter": "journeys-stop"
            }
        };
    },
    name: 'journeys',
    metaInfo: {
        title: 'Journeys',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'View the full list of journeys available on Sleep Jar and listen to previews to find your favorite!'
            },
            {
                'name': 'apple-itunes-app',
                'content': 'app-id=1587218079'
            }
        ]
    },
    methods: {
        filteredMediaRoughCount (type = "SOUND") {
            return this.filteredMediaCount(type) - this.filteredMediaCount(type)%10;
        },
        filteredMediaCount (type = "SOUND") {
            var keys = Object.keys(this.filteredMedia[type]);
            return keys.length;
        },
    },
    computed: {
        "filteredMedia": function(){
            let media = {
                "SOUND": {},
                "STORY": {},
                "MEDITATION": {},
                "JOURNEY": {}
            };
            Object.entries(this.media).forEach(function([key, item]){
                if(!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()){
                    media[item.type][key] = item;
                }
            });
            return media;
        },
    },
    components: {
    },
    mounted(){
        EventBus.$on(this.emit_config.emitter, function(key){
            var index = Object.keys(this.filteredMedia.STORY).indexOf(key);
            console.log("Emitter received key:", key);
            console.log("Mapped to index:", index);
            this.$refs.previews[index].stopAudio();
        }.bind(this));
    }
}
</script>
